module.exports = __webpack_public_path__ + "static/images/components/Popover/images/arrow-aside.5d9d1601.png";


//////////////////
// WEBPACK FOOTER
// ./components/Popover/images/arrow-aside.png
// module id = 2656
// module chunks = 11